import { MessageScreenProps } from './MessageScreen.decl';

import { Button, Flex, Spacer, Typography } from '@aircall/tractor';

export function MessageScreen({
  image,
  'data-test': dataTest = 'message-screen',
  title,
  subtitle,
  buttonText,
  onClick,
}: MessageScreenProps) {
  const Image = image;
  return (
    <Flex
      data-test={dataTest}
      height='100%'
      alignItems='center'
      justifyContent='center'
      backgroundColor='grey.lighter'
    >
      <Spacer direction='vertical' alignItems='center' space='xxl'>
        {Image && (
          <div data-test={`${dataTest}-image`}>
            <Image />
          </div>
        )}
        <Spacer direction='vertical' alignItems='center' space='xl'>
          <Spacer width={600} direction='vertical' alignItems='center' space='xxs'>
            <Typography variant='displayL' data-test='animated-screen-title'>
              {title}
            </Typography>
            <Typography variant='subheading2' textAlign='center'>
              {subtitle}
            </Typography>
          </Spacer>
          {onClick && buttonText && (
            <Button data-test={`${dataTest}-button`} onClick={onClick}>
              {buttonText}
            </Button>
          )}
        </Spacer>
      </Spacer>
    </Flex>
  );
}
